import {
  IFrontendInitOptions,
  ValidatedFrontendInitOptions,
  IBackendInitOptions,
  ValidatedBackendInitOptions,
} from '@staffbar/types';


// options, warnings, fatal error
export const validateFrontendOptions = (initOptions: IFrontendInitOptions): [ValidatedFrontendInitOptions, string[], boolean] => {
  // Handle the overriding of dev 
  var fatalError: boolean = false;
  var warnings: string[] = [];

  let { 
    dev,
    env,
    apiKey, 
    staffBarHost,
  } = initOptions

  let envOriginallyUndefined = env === undefined
  // We don't have an env
  env = env || 'dev'

  // If dev is true env must be 'dev'
  if (dev === true) {
    env = 'dev'
  } else if (dev === false) {
    // env shouldn't be dev, but we don't know what it should be
    if (env === 'dev') {
      if (envOriginallyUndefined) {

      } else {
        warnings.push('You have set dev: false but env is set to dev. This is an unsupported combination. Please set dev: true or change env.')
      }
    }
    // Else we're good
  } else if (dev === undefined) { 
    // If def is not set, figure it out from env
    if (env === 'dev') {
      dev = true
    } else {
      dev = false
    }
  }
  apiKey = apiKey ||  '-';
  staffBarHost = staffBarHost || 'https://app.staffbar.com'

  try { 
    new URL(staffBarHost)
  } catch(e) {
    // Invalid staffbar host
    warnings.push('Fatal: Unable to parse provided staffbar. Please check your staffBarHost value.')
    fatalError = true;
  }

  return [Object.assign({}, initOptions, {
    dev,
    env,
    apiKey,
    staffBarHost
  }), warnings, fatalError]
}

const allowedNodeEnvValuesForDev = [
  undefined,
  'dev',
  'development',
]

// options, warnings, fatal error
export const validateBackendOptions = (initOptions: IBackendInitOptions): [ValidatedBackendInitOptions, string[], boolean] => {
  // Handle the overriding of dev 
  var fatalError: boolean = false;
  var warnings: string[] = [];

  let { 
    dev,
    env,
    apiKey, 
    staffBarHost,
  } = initOptions

  let envOriginallyUndefined = env === undefined
  // We don't have an env
  env = env || 'dev'

  // If dev is true env must be 'dev'
  if (dev === true) {
    env = 'dev'
  } else if (dev === false) {
    // env shouldn't be dev, but we don't know what it should be
    if (env === 'dev') {
      if (envOriginallyUndefined) {

      } else {
        warnings.push('You have set dev: false but env is set to dev. This is an unsupported combination. Please set dev: true or change env.')
      }
    }
    // Else we're good
  } else if (dev === undefined) { 
    // If def is not set, figure it out from env
    if (env === 'dev') {
      dev = true
    } else {
      dev = false
    }
  }
  apiKey = apiKey ||  '-';
  staffBarHost = staffBarHost || 'https://app.staffbar.com'

  try { 
    new URL(staffBarHost)
  } catch(e) {
    // Invalid staffbar host
    warnings.push('Fatal: Unable to parse provided staffbar. Please check your staffBarHost value.')
    fatalError = true;
  }

  if (dev && !allowedNodeEnvValuesForDev.includes(process.env.NODE_ENV)) {
    warnings.push('Fatal: Refusing to start in dev mode because your NODE_ENV value is not `undefined`, `dev` or `development`.')
    fatalError = true;
  }

  return [Object.assign({}, initOptions, {
    dev,
    env,
    apiKey,
    staffBarHost
  }), warnings, fatalError]
}
